export default "__VITE_ASSET__BV_4ONQ8__"